module.exports = __webpack_public_path__ + "static/nookPic-1e181bc1bdd97392d5a6002231a3300c.png";